import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { SQUARE_SERVICES_URL } from '../constants/links';
import { useLanguage } from '../i18n/LanguageContext';

const StickyBookButton = () => {
  const { t } = useLanguage();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show button after scrolling past hero section
      if (window.scrollY > 400) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          className="fixed bottom-0 left-0 right-0 p-4 md:hidden z-50 bg-gradient-to-t from-white via-white to-transparent pb-6 pt-8"
        >
          <a
            href={SQUARE_SERVICES_URL}
            target="_blank"
            rel="noreferrer"
            className="block w-full bg-brand-dark text-white text-center py-4 rounded-full font-medium shadow-xl hover:bg-brand-taupe transition-colors"
          >
            {t('nav.bookAppointment')}
          </a>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default StickyBookButton;
